/* HC - Region-aware brand-menu hiding - 2026-08-01
 *
 * Hides brand links in the header navigation (desktop mega-menu + mobile
 * slide nav) for customers whose exact region tag matches a region in
 * assets/brand-region-restrictions.json — the build-time map produced by
 * tools/promo-feed/build-brand-region-map.mjs (a region is listed only when
 * EVERY customer-visible product in that brand collection carries the
 * region's restrict:* tag, the same rule as promo-card gating).
 *
 * Client-side on purpose: header HTML is page-cached and shared across
 * customers, so Liquid cannot personalize it — same reasoning as the rest of
 * the dynamic restriction surfaces (see PRODUCT_RESTRICTIONS.md). Guests
 * carry no region tags and are never affected. This is a merchandising
 * layer: collections stay reachable by URL/search, where product-level
 * gating takes over. Everything null-guards so the page degrades to the
 * unhidden menu if the policy engine or map is unavailable.
 */
(function () {
  'use strict';

  function init() {
    var policy = window.IBAccessPolicy;
    if (!policy || typeof policy.getCustomerContext !== 'function' ||
        typeof policy.customerMatchesRegionKey !== 'function') return;

    var customer = policy.getCustomerContext();
    // Fast bail for guests / customers with no region tags — the overwhelming
    // majority of sessions never fetch the map at all.
    var regionTags = (customer && (customer.regionTags || customer.customerRegionTags)) || [];
    var hasLegacyOntario = !!(customer && customer.tags && customer.tags.indexOf('ontario') !== -1);
    if (!regionTags.length && !hasLegacyOntario) return;

    var script = document.querySelector('script[data-ib-brand-region-map]');
    var mapUrl = script && script.getAttribute('data-ib-brand-region-map');
    if (!mapUrl) return;

    fetch(mapUrl).then(function (r) { return r.ok ? r.json() : null; }).then(function (map) {
      if (!map || !map.regionsByHandle) return;
      var blockedHandles = [];
      for (var handle in map.regionsByHandle) {
        if (!Object.prototype.hasOwnProperty.call(map.regionsByHandle, handle)) continue;
        var regions = map.regionsByHandle[handle] || [];
        for (var i = 0; i < regions.length; i++) {
          if (policy.customerMatchesRegionKey(customer, regions[i])) {
            blockedHandles.push(handle);
            break;
          }
        }
      }
      if (!blockedHandles.length) return;
      hide(blockedHandles);
    }).catch(function () { /* degrade to unhidden menu */ });
  }

  function hide(handles) {
    // Scope to header navigation surfaces only — never in-page content links.
    var scopes = document.querySelectorAll('#HeaderWrapper, .slide-nav__wrapper');
    for (var s = 0; s < scopes.length; s++) {
      for (var h = 0; h < handles.length; h++) {
        // Exact-handle match: '/collections/<handle>' at end or followed by ?/#
        var anchors = scopes[s].querySelectorAll('a[href*="/collections/' + handles[h] + '"]');
        for (var a = 0; a < anchors.length; a++) {
          var href = anchors[a].getAttribute('href') || '';
          var tail = href.split('/collections/')[1] || '';
          var handlePart = tail.split(/[?#\/]/)[0];
          if (handlePart !== handles[h]) continue; // e.g. 'matrix-1' must not match 'matrix-10'
          /* Containment guard: the desktop mega-menu renders brand links as
             bare anchors inside shared column divs — closest('li') there is
             the TOP-LEVEL nav item and hiding it removes the whole BRANDS
             dropdown (live bug, 2026-08-01). Only hide a wrapper when this
             anchor is its sole link; otherwise hide just the anchor. The
             mobile slide-nav's one-link-per-li still collapses cleanly. */
          var wrapper = anchors[a].closest('li, .megamenu__col-title');
          var target = (wrapper && wrapper.querySelectorAll('a').length === 1) ? wrapper : anchors[a];
          target.style.display = 'none';
          target.setAttribute('data-ib-region-hidden', '1');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
